import React from "react";
import { motion } from "framer-motion";

const ResponsibilityPage = () => {
  const sections = [
    {
      title: "Creating a Positive Impact",
      content: `At Bhagwati Products limited, we believe in playing our part to uplift communities and the environment through impactful CSR initiatives. Our efforts in rural infrastructure, education, and welfare programs help empower socio-economic development.`,
    },
    {
      title: "Ensuring Employee Welfare",
      content: `From free vaccination drives to oxygen support during the pandemic, Bhagwati has always prioritized the well-being of our employees, ensuring their safety and providing financial support where needed.`,
    },
    {
      title: "Preventive Steps Adopted at the Workplace",
      content: `Safety is our top priority. We implemented social distancing, work-from-home protocols, and provided PPE kits to safeguard our employees during the pandemic.`,
    },
  ];

  // const initiatives = [
  //   { icon: "", title: "Rural Infrastructure" },
  //   { icon: "", title: "Mid-day Meals" },
  //   { icon: "", title: "Education" },
  //   { icon: "", title: "Vaccination Drives" },
  //   { icon: "", title: "Healthcare Support" },
  //   { icon: "", title: "Ambulance Donation" },
  // ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative h-[80vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center blur"
          style={{
            backgroundImage: `url('https://th.bing.com/th/id/R.7d5e286a385b7d6c47cf5ed2d2675efc?rik=GCOpR1AfB8dsSQ&riu=http%3a%2f%2fwww.ssindia.net.in%2fassets%2fimages%2fabout-company.png&ehk=44BkjdwxAKBeqKeH6pmPvPFr0yawRpMIn%2fKi5KsmCVc%3d&risl=&pid=ImgRaw&r=0')`,
            backgroundPosition: "center 25%",
          }}
        >
          <div className="absolute inset-0  mix-blend-multiply" />
        </div>
        <div className="relative z-10 container mx-auto px-4">
          <motion.div
           
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-7xl font-bold tracking-tight mb-6 text-white">
              Our Responsibility
            </h1>
            <p className="text-lg md:text-2xl text-white mb-8">
              Creating a Positive Impact in Communities and Workplaces
            </p>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-16 space-y-20">
        {/* Content Sections */}
        {sections.map((section, index) => (
          <motion.section
            key={section.title}
           
            className={`flex flex-col ${
              index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
            } bg-gray-50 rounded-xl p-6 md:p-8 lg:p-12 mb-12 relative gap-8 lg:gap-12`}
          >
            {/* Left Section */}
            <div className="w-full lg:w-1/2 flex flex-col justify-center space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{section.title}</h2>
              <p className="text-gray-600 text-lg leading-relaxed">{section.content}</p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="self-start px-8 py-3 rounded-lg bg-orange-600 text-white font-semibold hover:bg-orange-700 transition-colors"
              >
                Learn More
              </motion.button>
            </div>

            {/* Right Section */}
            <div className="w-full lg:w-1/2 flex flex-col lg:flex-row items-center justify-center relative space-y-6 lg:space-y-0 lg:space-x-8">
              <motion.div
               
                className="bg-white  p-6 rounded-xl hover:shadow-xl transition-all border border-gray-200 w-full lg:w-1/2"
              >
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Explore CSR</h3>
                <p className="text-gray-600">
                  Our CSR activities focus on building a better tomorrow.
                </p>
              </motion.div>
              <motion.div
                
                className="bg-white  p-6 rounded-xl hover:shadow-xl transition-all border border-gray-200 w-full lg:w-1/2"
              >
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Sustainable Development</h3>
                <p className="text-gray-600">
                  Committed to social and environmental sustainability.
                </p>
              </motion.div>
            </div>
          </motion.section>
        ))}

        {/* Image Gallery
        <section className="py-24 bg-gray-50">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
            Our CSR Activities
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {Array.from({ length: 8 }).map((_, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative aspect-square overflow-hidden rounded-xl"
              >
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-lUdw4VSoEqkPRAxD7sIk7cXU2C4lHj.png"
                  alt={`CSR Activity ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                />
              </motion.div>
            ))}
          </div>
        </section> */}

        {/* Initiatives Grid */}
        {/* <section className="py-24 bg-white">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
            Our Key Initiatives
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {initiatives.map((initiative, index) => (
              <motion.div
                key={initiative.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className=" rounded-xl border hover:shadow-xl transition-shadow p-6 text-center"
              >
                <div className="text-4xl mb-4">{initiative.icon}</div>
                <h3 className="font-semibold text-lg text-gray-800">{initiative.title}</h3>
              </motion.div>
            ))}
          </div>
        </section> */}

       
      </div>
    </div>
  );
};

export default ResponsibilityPage;